import BaseHttpRepository from '../BaseHttpRepository';
import { HttpResponse } from 'core/base/HttpClient';
import Testimonials from 'domain/models/testimonials';

/**
 * TestimonialRepository
 * 
 * Fetches reviews from the WordPress REST API and maps them to the Testimonials domain model.
 */
export class TestimonialRepository extends BaseHttpRepository {
  endpoint = 'https://cms.zu.gt/wp-json/zu/v1/testimonials';

  list = async (params: { country?: string; brand?: string; page?: number; per_page?: number } = {}): Promise<HttpResponse> => {
    const defaultParams = { per_page: 50, page: 1 };
    const response = await this.client.get(this.endpoint, { ...defaultParams, ...params });
    
    const responseData = response.data as { success?: boolean; data?: any[]; meta?: any };
    const reviews = responseData.data || [];
    
    const mappedTestimonials: Testimonials[] = reviews.map((review: any) => ({
      id: review.id,
      testimony: review.content,
      name: review.author_name,
      job: review.author_position,
      rating: review.rating
    }));

    return {
      ...response,
      data: mappedTestimonials,
      meta: responseData.meta
    };
  }
}
